/**
 * icon by Austin Andrews @Templarian
 * https://materialdesignicons.com/icon/file-document
 */

import React from 'react'

const DocumentFileIcon = ({ width, height, fill }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24">
      <path
        fill={fill}
        d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z"
      />
    </svg>
  )
}

export default DocumentFileIcon
